module.exports = App.ApplicationSerialize = DS.ActiveModelSerializer.extend()